module.exports = (number) => {
	return new Intl.NumberFormat('id-ID', {style: 'currency', currency: 'IDR'}).format(number)
}